






















import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserList, QueryMemberAllList, QueryPartnerAllList, ExportUserList, FreezeUser, UnfreezeUser } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import HouseDescDialog from '@/views/house/HouseDescDialog.vue'
import { UserRoleFormat,MemberIsDemotionFormat,UserTypeFormat,TeamTypeFormat } from '@/utils/tyepconvert'
import ChangeRoleDialog from './ChangeRoleDialog.vue'
import constan from '@/utils/constant'
import MCBindMedicneCabinetDialog from '@/views/medicineCabinet/MCBindMedicneCabinetDialog.vue'
import InvestorIncomeDialog from './InvestorIncomeDialog.vue'
import UpdateUserInfoRoleDialog from './UpdateUserInfoRoleDialog.vue'
import UpdateUserInfoWealthDialog from './UpdateUserInfoWealthDialog.vue'
import UserWealthRecordDialog from './components/UserWealthRecordDialog.vue'
import UserPointsRecordDialog from './components/UserPointsRecordDialog.vue'
import UserActivityRecordDialog from './components/UserActivityRecordDialog.vue'
import ManualAdjustFrozenPointsDialog from './components/ManualAdjustFrozenPointsDialog.vue'
import MungBeanAllocateRechargeDialog from './components/MungBeanAllocateRechargeDialog.vue'
import UpdateUserInviteInfoDialog from './components/UpdateUserInviteInfoDialog.vue'
import CreateNewUserDialog from './components/CreateNewUserDialog.vue'
import { getUser } from '@/store/userStore'
import { MessageBox, Message } from 'element-ui'

@Component({
  components: {
    VQuery,
    VTable,
    HouseDescDialog,
    ChangeRoleDialog,
    MCBindMedicneCabinetDialog,
    InvestorIncomeDialog,
    UpdateUserInfoRoleDialog,
    UpdateUserInfoWealthDialog,
    UserWealthRecordDialog,
    UserPointsRecordDialog,
    UserActivityRecordDialog,
    ManualAdjustFrozenPointsDialog,
    MungBeanAllocateRechargeDialog,
    UpdateUserInviteInfoDialog,
    CreateNewUserDialog,
  },
})
export default class UserList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: []
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private memberList = []
  private partnerList = []
  private user = getUser()

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '渠道', param: 'channel' },
    { title: '用户ID', param: 'id' },
    { title: '手机号', param: 'mobilePhone' },
    { title: '昵称', param: 'nickname' },
    { title: '姓名', param: 'name' },
    // { title: '角色', param: 'role', type: 'select', selectData: constan.UserRole },
    { title: '会员', param: 'memberId', type: 'select', selectData: this.memberList },
    { title: '合伙人', param: 'partnerId', type: 'select', selectData: this.partnerList },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange', }
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '新增用户', type: 'primary', click: this.openCreateUser},
    { title: '导出', type: 'primary', click: this.exportOrderHandle},
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: '_index', type: 'index' },
    // { title: '渠道', param: 'channel' },
    { title: '用户ID',width: 100, param: 'id' },
    { title: '手机号',width: 120, param: 'mobilePhone' },
    { title: '昵称', param: 'nickname' },
    { title: '姓名', param: 'name' },
    // { title: '角色', param: 'role', formatter: UserRoleFormat },
    { title: '账户状态', width: 90, param: 'accountStatus', formatter: this.accountStatusFormat },
    { title: '用户类型',width: 100, param: 'userType', formatter: UserTypeFormat },
    { title: '用户位置',width: 150, param: 'userLocation' },
    { title: '战队类型',width: 100, param: 'teamType', formatter: TeamTypeFormat },
    { title: '合伙人名称',width: 120, param: 'partnerName' },
    { title: '推荐人ID', param: 'inviteUserId' , formatter: this.inviteUserIdFormat},
    { title: '会员名称', param: 'memberName' },
    { title: '绿豆数量', param: 'mungBeanQty' },
    { title: '积分(绿豆)', width: 120, param: 'frozenMungBeanQty' },
    { title: '总绿豆', width: 100, param: 'totalMungBeanQty' },
    { title: '贡献值数量',width: 120, param: 'contributionQty' },
    { title: '待入账贡献值',width: 120, param: 'waitContributionQty' },
    { title: '能量值', param: 'energyQty' },
    { title: '待入账能量值',width: 120, param: 'waitEnergyQty' },
    { title: '分红总绿豆',width: 120, param: 'distributionMungBeanQty' },
    { title: '直推人数', param: 'directQty' },
    { title: '当天/累计活跃度', width: 160, param: 'activityDayQty', formatter: this.formatActivityQty },
    { title: '是否手动分配过会员', param: 'isAllocateMember', formatter: this.isAllocateMemberFormat },
    // { title: '房子编号', param: 'houseCode' },
    { title: '创建时间',width: 160, param: 'createTime', formatter: DateFormat },
    {
      title: '操作',

      width: 520,


      fixed:'right',
      operation: [
        { title: '修改推荐人', click: this.openUpdateInviteInfo, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103} },
        { title: '修改身份', click: this.openUpdateRole, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103} },
        { title: '修改财富', click: this.openUpdateWealth, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103} },
        { title: '冻结用户', click: this.confirmFreezeUser, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103 && data.accountStatus !== 1} },
        { title: '解冻用户', click: this.confirmUnfreezeUser, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103 && data.accountStatus === 1} },
        { title: '账户明细', click: this.openWealthRecord },
        { title: '积分明细', click: this.openPointsRecord },
        { title: '活跃度流水', click: this.openActivityRecord },
        { title: '手动修改积分余额', click: this.openManualAdjustFrozenPoints, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103} },
        { title: '分配型绿豆充值', click: this.openMungBeanAllocateRecharge, show: (data)=>{return this.user.user.role != 2 && this.user.user.role != 103} },
        // { title: '绑定药柜', click: this.openBindMedicneCabinet, show: (data)=>{return data.role == 2} },
        // { title: '收益明细', click: this.openIncomeDesc, show: (data)=>{return data.role == 2} },
      ],
    },
  ]

  public async created() {
    this.loadData()
    this.loadQueryMemberAllList()
    this.loadQueryPartnerAllList()
  }

  private openCreateUser(){
    const d = this.$refs.CreateNewUserDialog as CreateNewUserDialog
    d.open()
  }

  private loadQueryMemberAllList(){
    QueryMemberAllList().then(res=>{
      this.memberList = res.map((e:any)=>{
        return  { label: e.name, value: e.id }
      })

      const m = this.queryModels.filter(e=>e.param == 'memberId')
      if(m.length > 0){
        m[0].selectData = this.memberList
      }
    })
  }
  private loadQueryPartnerAllList(){
    QueryPartnerAllList().then(res=>{
      this.partnerList = res.map((e:any)=>{
        return  { label: e.name, value: e.id }
      })

      const m = this.queryModels.filter(e=>e.param == 'partnerId')
      if(m.length > 0){
        m[0].selectData = this.partnerList
      }
    })
  }

  private isAllocateMemberFormat(v: number){
    if(!v){
      return '否'
    }
    return v == 1 ? "是" : "否"
  }

  private inviteUserIdFormat(v: number){
    if(!v || v == 0){
      return '-'
    }
    return v
  }


  private formatActivityQty(_cell: any, row: any) {
		const d = row.activityDayQty != null && row.activityDayQty !== '' ? row.activityDayQty : 0
		const t = row.activityTotalQty != null && row.activityTotalQty !== '' ? row.activityTotalQty : 0
		return d + ' / ' + t
	}
  private accountStatusFormat(v: number | null | undefined) {
    if (v === 1) {
      return '已冻结'
    }
    return '正常'
  }

  private confirmFreezeUser(data: any) {
    MessageBox.confirm(`确定冻结用户「${data.id}」${data.mobilePhone ? '（' + data.mobilePhone + '）' : ''}？冻结后将强制退出登录且不可再登录。`, '冻结用户', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        await FreezeUser({ userId: data.id })
        Message.success('已冻结')
        this.loadData()
      })
      .catch(() => undefined)
  }

  private confirmUnfreezeUser(data: any) {
    MessageBox.confirm(`确定解冻用户「${data.id}」${data.mobilePhone ? '（' + data.mobilePhone + '）' : ''}？解冻后用户可重新登录。`, '解冻用户', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        await UnfreezeUser({ userId: data.id })
        Message.success('已解冻')
        this.loadData()
      })
      .catch(() => undefined)

  }

  private openChangeRole(data: any){
    const d = this.$refs.ChangeRoleDialog as ChangeRoleDialog
    d.open(data)
  }

  private openIncomeDesc(data: any){
    const d = this.$refs.InvestorIncomeDialog as InvestorIncomeDialog
    d.open(data)
  }

  private openBindMedicneCabinet(data: any){
    // 绑定药柜
    const d = this.$refs.MCBindMedicneCabinetDialog as MCBindMedicneCabinetDialog
    d.open(data)
  }

  public openUpdateInviteInfo(data: any){
    const d = this.$refs.UpdateUserInviteInfoDialog as UpdateUserInviteInfoDialog
    d.open(data)
  }

  public openUpdateRole(data: any){
    const d = this.$refs.UpdateUserInfoRoleDialog as UpdateUserInfoRoleDialog
    d.open(data,true)
  }

  public openUpdateWealth(data: any){
    const d = this.$refs.UpdateUserInfoWealthDialog as UpdateUserInfoWealthDialog
    d.open(data,true)
  }

  public openWealthRecord(data:any){
    const d = this.$refs.UserWealthRecordDialog as UserWealthRecordDialog
    d.open({userId: data.id,mobilePhone: data.mobilePhone})
  }

  public openPointsRecord(data: any) {
    const d = this.$refs.UserPointsRecordDialog as UserPointsRecordDialog
    d.open({ userId: data.id })
  }

  public openActivityRecord(data: any) {
    const d = this.$refs.UserActivityRecordDialog as UserActivityRecordDialog
    d.open({ userId: data.id })
  }

  public openManualAdjustFrozenPoints(data: any) {
    const d = this.$refs.ManualAdjustFrozenPointsDialog as ManualAdjustFrozenPointsDialog
    d.open(data)
  }

  public openMungBeanAllocateRecharge(data: any) {
    const d = this.$refs.MungBeanAllocateRechargeDialog as MungBeanAllocateRechargeDialog
    d.open(data)
  }

  private exportOrderHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出用户积分记录',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      ExportUserList(param, "用户列表.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange.length >0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

}
